<!--
 * @Author: zhangcx33595
 * @Date: 2021-09-15 09:16:46
 * @LastEditors: zhangcx33595
 *desc: 消息提示框
 * @LastEditTime: 2021-10-25 17:03:25
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\components\tipPopup.vue
-->
<template>
  <div class="mask ecology-tips">
    <div class="cen">
      <svg
        v-if="dele"
        @click="_dele"
        t="1599629242171"
        class="dele"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2560"
        width="200"
        height="200"
      >
        <path
          d="M897.969231 842.830769L567.138462 512l330.830769-330.830769-55.138462-55.138462-330.830769 330.830769-330.830769-330.830769-55.138462 55.138462 330.830769 330.830769-330.830769 330.830769 55.138462 55.138462 330.830769-330.830769 330.830769 330.830769z"
          fill="#565656"
          p-id="2561"
        ></path>
      </svg>
      <img
        v-if="ifImg"
        class="status-img"
        src="@/assets/developerConference/isNoReady.png"
        alt=""
      />
      <p class="title">{{ title }}</p>
      <p class="tips">{{ tips }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "starPopup",
  props: {
    title: {
      type: String
    },
    tips: {
      type: String
    },
    dele: {
      type: Boolean,
      default: false
    },
    ifImg: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (!this.dele) {
      setTimeout(() => {
        this.$emit("update:show", false);
      }, 1000);
    }
  },
  methods: {
    _dele() {
      this.$emit("update:show", false);
    }
  }
};
</script>

<style scoped lang="scss">
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  opacity: 0.9;
}
.ecology-tips {
  display: flex;
  justify-content: center;
  align-items: center;
  .cen {
    position: relative;
    width: 540px;
    height: 230px;
    min-height: 180px;
    padding: 40px 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .dele {
      position: absolute;
      cursor: pointer;
      right: 20px;
      top: 20px;
      width: 30px;
      height: 30px;
    }
    img {
      width: 60px;
      height: 60px;
    }
    .title {
      font-size: 36px;
      font-weight: 700;
      color: #333333;
      line-height: 100px;
    }
    .tips {
      font-size: 28px;
      color: #333333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/components/tipPopup.vue